import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import APIserver from '../../../../api/axiosConfig'; // Asegúrate de tener la configuración correcta de Axios
import Swal from 'sweetalert2'; // Importamos SweetAlert2
import Select from 'react-select';

const SaldoPendienteModal = ({ show, handleClose }) => {
  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState('');
  const [monto, setMonto] = useState('');
  const [fecha, setFecha] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [loading, setLoading] = useState(true); // Estado de carga

  useEffect(() => {
    // Obtener los bancos cuando el modal se abra
    if (show) {
      fetchBancos();
    }
  }, [show]);

  // Al montar el componente, establecer la fecha actual
  useEffect(() => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const colombiaTime = new Date(today.getTime() - (offset * 60 * 1000));
    const formattedDate = colombiaTime.toISOString().split('T')[0]; // Convierte la fecha en formato YYYY-MM-DD
    setFecha(formattedDate); // Establece la fecha actual en el estado
}, []); // Se ejecuta solo una vez al montar el componente

  const fetchBancos = async () => {
    try {
      const response = await APIserver.get('/api/bancosLlamar'); // Endpoint para obtener bancos
      // Asegúrate de que la respuesta sea un array
      if (Array.isArray(response.data)) {
        setBancos(response.data);
      } else {
        console.error('La respuesta no es un array:', response.data);
      }
    } catch (error) {
      console.error('Error al obtener los bancos:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al obtener los bancos.',
      });
    } finally {
      setLoading(false); // Cambia el estado de carga cuando termine
    }
  };

  const handleSubmit = async () => {
    if (!selectedBanco || !monto || !fecha || !observaciones) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos Vacíos',
        text: 'Todos los campos son obligatorios.',
      });
      return;
    }

    try {
      const data = { idBanco: selectedBanco.value, monto, fecha, observaciones }; // Aquí extraemos el ID correctamente
      await APIserver.post('/api/saldo-pendiente', data);
      Swal.fire({
        icon: 'success',
        title: 'Registrado',
        text: 'Saldo pendiente registrado exitosamente.',
        timer: 2000,
        timerProgressBar: true,
        willClose: () => {
          window.location.reload();
        }
      });
      handleClose();
    } catch (error) {
      console.error('Error al registrar saldo pendiente:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al registrar el saldo pendiente.',
      });
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Registrar Saldo Pendiente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Campo para seleccionar el banco */}
          <Form.Group controlId="formBanco" className='m-3 mt-0'>
            <Form.Label>Banco</Form.Label>
            <Select
              options={bancos.map(banco => ({
                value: banco.idBanco,
                label: banco.nomBanco
              }))}
              isLoading={loading}
              placeholder="Selecciona un banco"
              value={selectedBanco} // Aquí debe ser un objeto, no solo el ID
              onChange={(selectedOption) => setSelectedBanco(selectedOption)} // Guardamos el objeto completo
            />
          </Form.Group>

          {/* Campo para monto */}
          <Form.Group controlId="formMonto" className='m-3'>
            <Form.Label>Monto</Form.Label>
            <Form.Control
              type="number"
              value={monto}
              onChange={(e) => setMonto(e.target.value)}
              placeholder="Monto"
            />
          </Form.Group>

          {/* Campo para fecha */}
          <Form.Group controlId="formFecha" className='m-3'>
            <Form.Label>Fecha</Form.Label>
            <Form.Control
              type="date"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </Form.Group>

          {/* Campo para observaciones */}
          <Form.Group controlId="formObservaciones" className='m-3'>
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              placeholder="Observaciones"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" onClick={handleClose}>
          Cerrar
        </Button>
        <Button variant="danger" onClick={handleSubmit}>
          Registrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaldoPendienteModal;
